// extracted by mini-css-extract-plugin
module.exports = {"resultPageItem":"GameCongratulation_resultPageItem__3MIOC"};